export function StepHeading({ children }) {
  return <h1 className="text-2xl font-semibold tracking-tight text-center sm:text-3xl">{children}</h1>;
}
